module.exports = __webpack_public_path__ + "static/media/sale.297f6d1a.svg";